import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Allocation } from '@lib/models/generated/graphql';
import { OuiDialogService } from 'omnium-ui/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AddFichierAllocationDialogComponent } from 'src/app/components/admin-page/admin-fichiers-allocation/add-fichier-allocation-dialog/add-fichier-allocation-dialog.component';
import {
  AllocationColumn,
  DateModificationColumn,
  FileColumn,
  IdColumn,
  NameColumn,
  RisqueColumn,
} from 'src/app/components/admin-page/admin-fichiers-allocation/allocation-table/allocation-column';
import { AllocationService, DataAllocation } from 'src/app/services/allocation.service';

@Component({
  selector: 'app-fichiers-allocation',
  templateUrl: './fichiers-allocation.component.html',
  styleUrls: ['./fichiers-allocation.component.scss'],
})
export class FichiersAllocationComponent {
  columnSelection: AllocationColumn[] = [
    new IdColumn(),
    new NameColumn(),
    new RisqueColumn(),
    new FileColumn(),
    new DateModificationColumn(),
  ];
  displayedColumns: string[] = this.columnSelection.map(column => column.header);
  requestResult: { data: { items: Allocation[]; totalCount: number }; loading: boolean } | undefined;
  filterNameControl: FormControl<string | null> = new FormControl<string>('');
  constructor(private allocationService: AllocationService, private dialogService: OuiDialogService) {
    this.allocationService.allocationsSubject.subscribe(result => {
      this.setRequestResult(result);
    });
    this.fetchAllocations();
    this.requestResult = { data: { items: [], totalCount: 0 }, loading: true };
    this.filterNameControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
      this.fetchAllocations();
    });
  }

  fetchAllocations() {
    this.requestResult = { data: { items: [], totalCount: 0 }, loading: true };
    this.allocationService.loadAllAllocations();
  }

  setRequestResult(data: DataAllocation) {
    const filtered = this.withFilters(data.allocations);
    this.requestResult = {
      data: { items: filtered, totalCount: filtered.length },
      loading: data.loading,
    };
  }
  withFilters(allocations: Allocation[]) {
    const searchTerm = this.filterNameControl.value;
    if (!searchTerm) return allocations;
    return allocations.filter(allocation => {
      return allocation.libelle.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }

  onRowClick(selected: Allocation) {
    if (selected) {
      const typeRef = this.dialogService.openDialog(
        AddFichierAllocationDialogComponent,
        {
          allocation: selected,
        },
        'auto',
        '616px'
      );
      typeRef.afterClosed().subscribe(result => {
        //nothing to do
      });
    }
  }
}
